import * as Tab from '@radix-ui/react-tabs';
import React from 'react';
import { ChoiceChip } from '../Chip/ChoiceChip/ChoiceChip';
export const TabChip = ({
  tab,
  buttonChipProps,
  onTabSelect,
  isActive,
  size,
  dynamicTabWidth
}) => {
  return React.createElement(Tab.Trigger, {
    asChild: true,
    value: `tab-${tab.id}`,
    key: `tab-${tab.id}`
  }, React.createElement(ChoiceChip, {
    width: dynamicTabWidth ? '100%' : 'auto',
    onClick: () => onTabSelect(),
    ...buttonChipProps,
    Icon: tab.icon,
    label: tab.text,
    selected: isActive === tab.id,
    size: size
  }));
};